import { BreachScreenType, CartEvent } from '@news-mono/web-common'
import { getAttribution } from '../../errors/ErrorPage'
import { Theme } from '@emotion/react'
import {
    SubscriptionPackageOptions,
    SubscriptionPriceObject,
} from '../../user-registration/breach/helpers/BreachWallTypes'

export const TEACHERS_OFFER = 'teachers-offer'
export const UNIVERSITY_OFFER = 'university-offer'
export const FREE_TRIAL_OFFER = 'free-trial-offer'
export const INTRO_25_OFFER = 'intro-25-offer'

//The default quantity used for all GA4 events
export const DEFAULT_CART_QUANTITY = 4

// The quantity used for annual subscriptions on GA4 events
const ANNUAL_CART_QUANTITY = 52
const QUARTERLY_CART_QUANTITY = 12

export type SwgPackageOptions = {
    quantity?: number
    promoPrice?: string
    originalPrice?: string
    modifier?: string
    discount?: number
    coupon?: string
    varient?: 'swg' | 'native'
}

type SubscriptionPackage = {
    price: SubscriptionPriceObject
    package: SubscriptionPackageOptions
}

/**
 * This will generate a new cart event payload, which is used to send to the GTM layer.
 *
 * @param packageInfo - the package to remove from cart
 * @param mastheadTheme - the theme to apply, used for brand identification
 * @param options - any page price options, including quantity
 * @param breachScreenType - only when passed through is this provided
 */
export function getCartPayload(
    packageInfo: SubscriptionPackage | undefined,
    mastheadTheme: Theme | string,
    options?: SwgPackageOptions,
    breachScreenType?: BreachScreenType,
): CartEvent['payload'] | undefined {
    if (!packageInfo) {
        return undefined
    }

    const item_brand =
        typeof mastheadTheme === 'string'
            ? mastheadTheme
            : getAttribution(mastheadTheme.kind, mastheadTheme.section) ||
              'The West Australian'

    const item_id = packageInfo.price.rateCode
    const price = packageInfo.price.weeklyPrice
    const promoPrice = packageInfo.price.promoPrice ?? 0
    const discount = packageInfo.price.discount ?? 0
    const item_name = packageInfo.package.heading
    const coupon = packageInfo.price.offerCode ?? ''

    // Is the selected rateCode an annual package?
    const isAnnualPackage = ['WST_DIGI_12MTH25OFF'].includes(item_id)
    const isQuarterlyPackage = ['WST_DIG_4X12CRKT'].includes(item_id)

    // Use the options if provided, otherwise use defaults based on rateCode (item_id)
    const quantity = options?.quantity
        ? options?.quantity
        : isAnnualPackage
        ? ANNUAL_CART_QUANTITY
        : isQuarterlyPackage
        ? QUARTERLY_CART_QUANTITY
        : DEFAULT_CART_QUANTITY

    // now using the set values, create a payload
    return {
        currency: 'AUD',
        value: (promoPrice > 0 ? promoPrice : price) * quantity,
        items: [
            {
                item_id: item_id,
                item_brand: item_brand,
                item_name: item_name,
                price: price,
                promo_price: promoPrice,
                discount: discount,
                coupon: coupon,
                quantity: quantity,
                item_variant: options?.varient || 'native',
            },
        ],
        breachScreenType: breachScreenType || undefined,
    }
}
